import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _099c6ee5 = () => interopDefault(import('../../../pages/activity.vue' /* webpackChunkName: "pages/activity" */))
const _ccab72f8 = () => interopDefault(import('../../../pages/chatbot-preview.vue' /* webpackChunkName: "pages/chatbot-preview" */))
const _1e2c21de = () => interopDefault(import('../../../pages/commands.vue' /* webpackChunkName: "pages/commands" */))
const _bfc0d3fc = () => interopDefault(import('../../../pages/commissions.vue' /* webpackChunkName: "pages/commissions" */))
const _5faa521a = () => interopDefault(import('../../../pages/consultation-scripts.vue' /* webpackChunkName: "pages/consultation-scripts" */))
const _0cdbd8c8 = () => interopDefault(import('../../../pages/crm-opportunities.vue' /* webpackChunkName: "pages/crm-opportunities" */))
const _021c2bdb = () => interopDefault(import('../../../pages/diff.vue' /* webpackChunkName: "pages/diff" */))
const _fdf3b89e = () => interopDefault(import('../../../pages/email-preview.vue' /* webpackChunkName: "pages/email-preview" */))
const _736905ae = () => interopDefault(import('../../../pages/employer-plans.vue' /* webpackChunkName: "pages/employer-plans" */))
const _218845a0 = () => interopDefault(import('../../../pages/employer-report.vue' /* webpackChunkName: "pages/employer-report" */))
const _08a786b2 = () => interopDefault(import('../../../pages/employers.vue' /* webpackChunkName: "pages/employers" */))
const _5d1c5daa = () => interopDefault(import('../../../pages/enroll-thank-you.vue' /* webpackChunkName: "pages/enroll-thank-you" */))
const _3131bf9f = () => interopDefault(import('../../../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _b94137fc = () => interopDefault(import('../../../pages/intake.vue' /* webpackChunkName: "pages/intake" */))
const _77ea117b = () => interopDefault(import('../../../pages/keep-plans/index.vue' /* webpackChunkName: "pages/keep-plans/index" */))
const _13d8d8ac = () => interopDefault(import('../../../pages/link-login.vue' /* webpackChunkName: "pages/link-login" */))
const _df8474fa = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _27fd77cd = () => interopDefault(import('../../../pages/magic-redirect-error.vue' /* webpackChunkName: "pages/magic-redirect-error" */))
const _7447b278 = () => interopDefault(import('../../../pages/mistake.vue' /* webpackChunkName: "pages/mistake" */))
const _4049ab66 = () => interopDefault(import('../../../pages/print-window.vue' /* webpackChunkName: "pages/print-window" */))
const _42bcc079 = () => interopDefault(import('../../../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _061f69a0 = () => interopDefault(import('../../../pages/schedule/index.vue' /* webpackChunkName: "pages/schedule/index" */))
const _9025f704 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _6f3ee40e = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _436ed57a = () => interopDefault(import('../../../pages/summary/index.vue' /* webpackChunkName: "pages/summary/index" */))
const _3c160d7b = () => interopDefault(import('../../../pages/summary-scripts.vue' /* webpackChunkName: "pages/summary-scripts" */))
const _5247ffb3 = () => interopDefault(import('../../../pages/survey/index.vue' /* webpackChunkName: "pages/survey/index" */))
const _00184e56 = () => interopDefault(import('../../../pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _b2610b20 = () => interopDefault(import('../../../pages/email/appointment-canceled.vue' /* webpackChunkName: "pages/email/appointment-canceled" */))
const _777a83cb = () => interopDefault(import('../../../pages/email/appointment-phone-confirmation.vue' /* webpackChunkName: "pages/email/appointment-phone-confirmation" */))
const _726f6d53 = () => interopDefault(import('../../../pages/email/appointment-rescheduled.vue' /* webpackChunkName: "pages/email/appointment-rescheduled" */))
const _7f195cac = () => interopDefault(import('../../../pages/email/appointment-survey-complete-reminder.vue' /* webpackChunkName: "pages/email/appointment-survey-complete-reminder" */))
const _2743aaa5 = () => interopDefault(import('../../../pages/email/appointment-survey-incomplete-reminder.vue' /* webpackChunkName: "pages/email/appointment-survey-incomplete-reminder" */))
const _29f7085e = () => interopDefault(import('../../../pages/email/appointment-video-confirmation.vue' /* webpackChunkName: "pages/email/appointment-video-confirmation" */))
const _7000c57a = () => interopDefault(import('../../../pages/email/client-email-consultation.vue' /* webpackChunkName: "pages/email/client-email-consultation" */))
const _498e0a43 = () => interopDefault(import('../../../pages/email/client-survey-consultation.vue' /* webpackChunkName: "pages/email/client-survey-consultation" */))
const _78dc3343 = () => interopDefault(import('../../../pages/email/email-consultation.vue' /* webpackChunkName: "pages/email/email-consultation" */))
const _02b2da9a = () => interopDefault(import('../../../pages/email/email-verify.vue' /* webpackChunkName: "pages/email/email-verify" */))
const _ba2545a6 = () => interopDefault(import('../../../pages/email/employer-report.vue' /* webpackChunkName: "pages/email/employer-report" */))
const _618ee1d6 = () => interopDefault(import('../../../pages/email/light-summary.vue' /* webpackChunkName: "pages/email/light-summary" */))
const _de870602 = () => interopDefault(import('../../../pages/email/link-login.vue' /* webpackChunkName: "pages/email/link-login" */))
const _7a83a05c = () => interopDefault(import('../../../pages/email/otp.vue' /* webpackChunkName: "pages/email/otp" */))
const _2b4b5b72 = () => interopDefault(import('../../../pages/email/pdf-summary.vue' /* webpackChunkName: "pages/email/pdf-summary" */))
const _5197116e = () => interopDefault(import('../../../pages/email/pre-consult-survey.vue' /* webpackChunkName: "pages/email/pre-consult-survey" */))
const _6e432c82 = () => interopDefault(import('../../../pages/email/reset-password.vue' /* webpackChunkName: "pages/email/reset-password" */))
const _d373d966 = () => interopDefault(import('../../../pages/email/summary.vue' /* webpackChunkName: "pages/email/summary" */))
const _6f07aef6 = () => interopDefault(import('../../../pages/email/support.vue' /* webpackChunkName: "pages/email/support" */))
const _d529a69e = () => interopDefault(import('../../../pages/email/task-done.vue' /* webpackChunkName: "pages/email/task-done" */))
const _e86f170a = () => interopDefault(import('../../../pages/email/test.vue' /* webpackChunkName: "pages/email/test" */))
const _03d37fa3 = () => interopDefault(import('../../../pages/email/zen-summary.vue' /* webpackChunkName: "pages/email/zen-summary" */))
const _a26afe26 = () => interopDefault(import('../../../pages/survey/aep.vue' /* webpackChunkName: "pages/survey/aep" */))
const _4cbf5e6a = () => interopDefault(import('../../../pages/survey/completion.vue' /* webpackChunkName: "pages/survey/completion" */))
const _335baf9d = () => interopDefault(import('../../../pages/survey/demographics.vue' /* webpackChunkName: "pages/survey/demographics" */))
const _da389998 = () => interopDefault(import('../../../pages/survey/drugs.vue' /* webpackChunkName: "pages/survey/drugs" */))
const _e013b8d0 = () => interopDefault(import('../../../pages/survey/income.vue' /* webpackChunkName: "pages/survey/income" */))
const _266a8f90 = () => interopDefault(import('../../../pages/survey/landing.vue' /* webpackChunkName: "pages/survey/landing" */))
const _5ede27c1 = () => interopDefault(import('../../../pages/survey/new.vue' /* webpackChunkName: "pages/survey/new" */))
const _463dbf00 = () => interopDefault(import('../../../pages/survey/pharmacies.vue' /* webpackChunkName: "pages/survey/pharmacies" */))
const _2d5170e4 = () => interopDefault(import('../../../pages/survey/plans/index.vue' /* webpackChunkName: "pages/survey/plans/index" */))
const _41e949fa = () => interopDefault(import('../../../pages/survey/providers.vue' /* webpackChunkName: "pages/survey/providers" */))
const _7737c126 = () => interopDefault(import('../../../pages/survey/soa.vue' /* webpackChunkName: "pages/survey/soa" */))
const _5a977130 = () => interopDefault(import('../../../pages/survey/step-by-step.vue' /* webpackChunkName: "pages/survey/step-by-step" */))
const _efe47372 = () => interopDefault(import('../../../pages/survey/summary.vue' /* webpackChunkName: "pages/survey/summary" */))
const _622307fa = () => interopDefault(import('../../../pages/survey/welcome.vue' /* webpackChunkName: "pages/survey/welcome" */))
const _72d3bb28 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _161db53a = () => interopDefault(import('../../../pages/survey/plans/_pids.vue' /* webpackChunkName: "pages/survey/plans/_pids" */))
const _61630797 = () => interopDefault(import('../../../pages/group/_slug/index.vue' /* webpackChunkName: "pages/group/_slug/index" */))
const _079cf5ec = () => interopDefault(import('../../../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _098cac30 = () => interopDefault(import('../../../pages/schedule/_slug.vue' /* webpackChunkName: "pages/schedule/_slug" */))
const _55969a26 = () => interopDefault(import('../../../pages/start-enrollment/_pid.vue' /* webpackChunkName: "pages/start-enrollment/_pid" */))
const _f31de72a = () => interopDefault(import('../../../pages/summary/_id.vue' /* webpackChunkName: "pages/summary/_id" */))
const _630461c3 = () => interopDefault(import('../../../pages/survey/_uid/index.vue' /* webpackChunkName: "pages/survey/_uid/index" */))
const _481ae3f0 = () => interopDefault(import('../../../pages/group/_slug/articles.vue' /* webpackChunkName: "pages/group/_slug/articles" */))
const _bc0289d0 = () => interopDefault(import('../../../pages/group/_slug/drugs.vue' /* webpackChunkName: "pages/group/_slug/drugs" */))
const _3ae57568 = () => interopDefault(import('../../../pages/group/_slug/faqs.vue' /* webpackChunkName: "pages/group/_slug/faqs" */))
const _9bfa7a9c = () => interopDefault(import('../../../pages/group/_slug/frame.vue' /* webpackChunkName: "pages/group/_slug/frame" */))
const _75f95ac4 = () => interopDefault(import('../../../pages/group/_slug/reports.vue' /* webpackChunkName: "pages/group/_slug/reports" */))
const _41b28263 = () => interopDefault(import('../../../pages/group/_slug/videos.vue' /* webpackChunkName: "pages/group/_slug/videos" */))
const _0f671e14 = () => interopDefault(import('../../../pages/group/_slug/webinars.vue' /* webpackChunkName: "pages/group/_slug/webinars" */))
const _0b395c2e = () => interopDefault(import('../../../pages/survey/_uid/activity.vue' /* webpackChunkName: "pages/survey/_uid/activity" */))
const _274fb206 = () => interopDefault(import('../../../pages/survey/_uid/aep.vue' /* webpackChunkName: "pages/survey/_uid/aep" */))
const _349eb8bb = () => interopDefault(import('../../../pages/survey/_uid/completion.vue' /* webpackChunkName: "pages/survey/_uid/completion" */))
const _6f4048e6 = () => interopDefault(import('../../../pages/survey/_uid/demographics.vue' /* webpackChunkName: "pages/survey/_uid/demographics" */))
const _b8bfd578 = () => interopDefault(import('../../../pages/survey/_uid/drugs.vue' /* webpackChunkName: "pages/survey/_uid/drugs" */))
const _76db014c = () => interopDefault(import('../../../pages/survey/_uid/editor.vue' /* webpackChunkName: "pages/survey/_uid/editor" */))
const _804fbfca = () => interopDefault(import('../../../pages/survey/_uid/enrollment-period.vue' /* webpackChunkName: "pages/survey/_uid/enrollment-period" */))
const _e87804ba = () => interopDefault(import('../../../pages/survey/_uid/health-lifestyle.vue' /* webpackChunkName: "pages/survey/_uid/health-lifestyle" */))
const _5f3c4584 = () => interopDefault(import('../../../pages/survey/_uid/income-surcharges.vue' /* webpackChunkName: "pages/survey/_uid/income-surcharges" */))
const _80125370 = () => interopDefault(import('../../../pages/survey/_uid/landing.vue' /* webpackChunkName: "pages/survey/_uid/landing" */))
const _bd87b220 = () => interopDefault(import('../../../pages/survey/_uid/pharmacies.vue' /* webpackChunkName: "pages/survey/_uid/pharmacies" */))
const _23b444c4 = () => interopDefault(import('../../../pages/survey/_uid/plans/index.vue' /* webpackChunkName: "pages/survey/_uid/plans/index" */))
const _d0af95da = () => interopDefault(import('../../../pages/survey/_uid/providers.vue' /* webpackChunkName: "pages/survey/_uid/providers" */))
const _28b2c746 = () => interopDefault(import('../../../pages/survey/_uid/quick-aep.vue' /* webpackChunkName: "pages/survey/_uid/quick-aep" */))
const _2b392d39 = () => interopDefault(import('../../../pages/survey/_uid/soa/index.vue' /* webpackChunkName: "pages/survey/_uid/soa/index" */))
const _20c8c5c0 = () => interopDefault(import('../../../pages/survey/_uid/step-by-step.vue' /* webpackChunkName: "pages/survey/_uid/step-by-step" */))
const _5b39e457 = () => interopDefault(import('../../../pages/survey/_uid/summary.vue' /* webpackChunkName: "pages/survey/_uid/summary" */))
const _bbcacbda = () => interopDefault(import('../../../pages/survey/_uid/welcome.vue' /* webpackChunkName: "pages/survey/_uid/welcome" */))
const _0c80891a = () => interopDefault(import('../../../pages/survey/_uid/plans/_pids.vue' /* webpackChunkName: "pages/survey/_uid/plans/_pids" */))
const _7f50de78 = () => interopDefault(import('../../../pages/survey/_uid/soa/_sid.vue' /* webpackChunkName: "pages/survey/_uid/soa/_sid" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/activity",
    component: _099c6ee5,
    name: "activity"
  }, {
    path: "/chatbot-preview",
    component: _ccab72f8,
    name: "chatbot-preview"
  }, {
    path: "/commands",
    component: _1e2c21de,
    name: "commands"
  }, {
    path: "/commissions",
    component: _bfc0d3fc,
    name: "commissions"
  }, {
    path: "/consultation-scripts",
    component: _5faa521a,
    name: "consultation-scripts"
  }, {
    path: "/crm-opportunities",
    component: _0cdbd8c8,
    name: "crm-opportunities"
  }, {
    path: "/diff",
    component: _021c2bdb,
    name: "diff"
  }, {
    path: "/email-preview",
    component: _fdf3b89e,
    name: "email-preview"
  }, {
    path: "/employer-plans",
    component: _736905ae,
    name: "employer-plans"
  }, {
    path: "/employer-report",
    component: _218845a0,
    name: "employer-report"
  }, {
    path: "/employers",
    component: _08a786b2,
    name: "employers"
  }, {
    path: "/enroll-thank-you",
    component: _5d1c5daa,
    name: "enroll-thank-you"
  }, {
    path: "/forgot-password",
    component: _3131bf9f,
    name: "forgot-password"
  }, {
    path: "/intake",
    component: _b94137fc,
    name: "intake"
  }, {
    path: "/keep-plans",
    component: _77ea117b,
    name: "keep-plans"
  }, {
    path: "/link-login",
    component: _13d8d8ac,
    name: "link-login"
  }, {
    path: "/login",
    component: _df8474fa,
    name: "login"
  }, {
    path: "/magic-redirect-error",
    component: _27fd77cd,
    name: "magic-redirect-error"
  }, {
    path: "/mistake",
    component: _7447b278,
    name: "mistake"
  }, {
    path: "/print-window",
    component: _4049ab66,
    name: "print-window"
  }, {
    path: "/register",
    component: _42bcc079,
    name: "register"
  }, {
    path: "/schedule",
    component: _061f69a0,
    name: "schedule"
  }, {
    path: "/search",
    component: _9025f704,
    name: "search"
  }, {
    path: "/settings",
    component: _6f3ee40e,
    name: "settings"
  }, {
    path: "/summary",
    component: _436ed57a,
    name: "summary"
  }, {
    path: "/summary-scripts",
    component: _3c160d7b,
    name: "summary-scripts"
  }, {
    path: "/survey",
    component: _5247ffb3,
    name: "survey"
  }, {
    path: "/thank-you",
    component: _00184e56,
    name: "thank-you"
  }, {
    path: "/email/appointment-canceled",
    component: _b2610b20,
    name: "email-appointment-canceled"
  }, {
    path: "/email/appointment-phone-confirmation",
    component: _777a83cb,
    name: "email-appointment-phone-confirmation"
  }, {
    path: "/email/appointment-rescheduled",
    component: _726f6d53,
    name: "email-appointment-rescheduled"
  }, {
    path: "/email/appointment-survey-complete-reminder",
    component: _7f195cac,
    name: "email-appointment-survey-complete-reminder"
  }, {
    path: "/email/appointment-survey-incomplete-reminder",
    component: _2743aaa5,
    name: "email-appointment-survey-incomplete-reminder"
  }, {
    path: "/email/appointment-video-confirmation",
    component: _29f7085e,
    name: "email-appointment-video-confirmation"
  }, {
    path: "/email/client-email-consultation",
    component: _7000c57a,
    name: "email-client-email-consultation"
  }, {
    path: "/email/client-survey-consultation",
    component: _498e0a43,
    name: "email-client-survey-consultation"
  }, {
    path: "/email/email-consultation",
    component: _78dc3343,
    name: "email-email-consultation"
  }, {
    path: "/email/email-verify",
    component: _02b2da9a,
    name: "email-email-verify"
  }, {
    path: "/email/employer-report",
    component: _ba2545a6,
    name: "email-employer-report"
  }, {
    path: "/email/light-summary",
    component: _618ee1d6,
    name: "email-light-summary"
  }, {
    path: "/email/link-login",
    component: _de870602,
    name: "email-link-login"
  }, {
    path: "/email/otp",
    component: _7a83a05c,
    name: "email-otp"
  }, {
    path: "/email/pdf-summary",
    component: _2b4b5b72,
    name: "email-pdf-summary"
  }, {
    path: "/email/pre-consult-survey",
    component: _5197116e,
    name: "email-pre-consult-survey"
  }, {
    path: "/email/reset-password",
    component: _6e432c82,
    name: "email-reset-password"
  }, {
    path: "/email/summary",
    component: _d373d966,
    name: "email-summary"
  }, {
    path: "/email/support",
    component: _6f07aef6,
    name: "email-support"
  }, {
    path: "/email/task-done",
    component: _d529a69e,
    name: "email-task-done"
  }, {
    path: "/email/test",
    component: _e86f170a,
    name: "email-test"
  }, {
    path: "/email/zen-summary",
    component: _03d37fa3,
    name: "email-zen-summary"
  }, {
    path: "/survey/aep",
    component: _a26afe26,
    name: "survey-aep"
  }, {
    path: "/survey/completion",
    component: _4cbf5e6a,
    name: "survey-completion"
  }, {
    path: "/survey/demographics",
    component: _335baf9d,
    name: "survey-demographics"
  }, {
    path: "/survey/drugs",
    component: _da389998,
    name: "survey-drugs"
  }, {
    path: "/survey/income",
    component: _e013b8d0,
    name: "survey-income"
  }, {
    path: "/survey/landing",
    component: _266a8f90,
    name: "survey-landing"
  }, {
    path: "/survey/new",
    component: _5ede27c1,
    name: "survey-new"
  }, {
    path: "/survey/pharmacies",
    component: _463dbf00,
    name: "survey-pharmacies"
  }, {
    path: "/survey/plans",
    component: _2d5170e4,
    name: "survey-plans"
  }, {
    path: "/survey/providers",
    component: _41e949fa,
    name: "survey-providers"
  }, {
    path: "/survey/soa",
    component: _7737c126,
    name: "survey-soa"
  }, {
    path: "/survey/step-by-step",
    component: _5a977130,
    name: "survey-step-by-step"
  }, {
    path: "/survey/summary",
    component: _efe47372,
    name: "survey-summary"
  }, {
    path: "/survey/welcome",
    component: _622307fa,
    name: "survey-welcome"
  }, {
    path: "/",
    component: _72d3bb28,
    name: "index"
  }, {
    path: "/survey/plans/:pids",
    component: _161db53a,
    name: "survey-plans-pids"
  }, {
    path: "/group/:slug",
    component: _61630797,
    name: "group-slug"
  }, {
    path: "/reset-password/:token?",
    component: _079cf5ec,
    name: "reset-password-token"
  }, {
    path: "/schedule/:slug",
    component: _098cac30,
    name: "schedule-slug"
  }, {
    path: "/start-enrollment/:pid?",
    component: _55969a26,
    name: "start-enrollment-pid"
  }, {
    path: "/summary/:id",
    component: _f31de72a,
    name: "summary-id"
  }, {
    path: "/survey/:uid",
    component: _630461c3,
    name: "survey-uid"
  }, {
    path: "/group/:slug?/articles",
    component: _481ae3f0,
    name: "group-slug-articles"
  }, {
    path: "/group/:slug?/drugs",
    component: _bc0289d0,
    name: "group-slug-drugs"
  }, {
    path: "/group/:slug?/faqs",
    component: _3ae57568,
    name: "group-slug-faqs"
  }, {
    path: "/group/:slug?/frame",
    component: _9bfa7a9c,
    name: "group-slug-frame"
  }, {
    path: "/group/:slug?/reports",
    component: _75f95ac4,
    name: "group-slug-reports"
  }, {
    path: "/group/:slug?/videos",
    component: _41b28263,
    name: "group-slug-videos"
  }, {
    path: "/group/:slug?/webinars",
    component: _0f671e14,
    name: "group-slug-webinars"
  }, {
    path: "/survey/:uid/activity",
    component: _0b395c2e,
    name: "survey-uid-activity"
  }, {
    path: "/survey/:uid/aep",
    component: _274fb206,
    name: "survey-uid-aep"
  }, {
    path: "/survey/:uid/completion",
    component: _349eb8bb,
    name: "survey-uid-completion"
  }, {
    path: "/survey/:uid/demographics",
    component: _6f4048e6,
    name: "survey-uid-demographics"
  }, {
    path: "/survey/:uid/drugs",
    component: _b8bfd578,
    name: "survey-uid-drugs"
  }, {
    path: "/survey/:uid/editor",
    component: _76db014c,
    name: "survey-uid-editor"
  }, {
    path: "/survey/:uid/enrollment-period",
    component: _804fbfca,
    name: "survey-uid-enrollment-period"
  }, {
    path: "/survey/:uid/health-lifestyle",
    component: _e87804ba,
    name: "survey-uid-health-lifestyle"
  }, {
    path: "/survey/:uid/income-surcharges",
    component: _5f3c4584,
    name: "survey-uid-income-surcharges"
  }, {
    path: "/survey/:uid/landing",
    component: _80125370,
    name: "survey-uid-landing"
  }, {
    path: "/survey/:uid/pharmacies",
    component: _bd87b220,
    name: "survey-uid-pharmacies"
  }, {
    path: "/survey/:uid/plans",
    component: _23b444c4,
    name: "survey-uid-plans"
  }, {
    path: "/survey/:uid/providers",
    component: _d0af95da,
    name: "survey-uid-providers"
  }, {
    path: "/survey/:uid/quick-aep",
    component: _28b2c746,
    name: "survey-uid-quick-aep"
  }, {
    path: "/survey/:uid/soa",
    component: _2b392d39,
    name: "survey-uid-soa"
  }, {
    path: "/survey/:uid/step-by-step",
    component: _20c8c5c0,
    name: "survey-uid-step-by-step"
  }, {
    path: "/survey/:uid/summary",
    component: _5b39e457,
    name: "survey-uid-summary"
  }, {
    path: "/survey/:uid/welcome",
    component: _bbcacbda,
    name: "survey-uid-welcome"
  }, {
    path: "/survey/:uid/plans/:pids",
    component: _0c80891a,
    name: "survey-uid-plans-pids"
  }, {
    path: "/survey/:uid/soa/:sid",
    component: _7f50de78,
    name: "survey-uid-soa-sid"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
